export const getIconSize = (size: string | undefined) => {
  switch (size) {
    case "xs":
      return 10
    case "sm":
      return 14
    case "md":
      return 18
    case "lg":
      return 22
    default:
      return 14
  }
}
